<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ------------------------------------------------ ----------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-list-view" class="data-list-container">
    <div class="vx-row w-full">
      <div class="vx-col lg:w-1/2 w-full">
        <vx-card class="flex-1" :title="$t('CourseRegistration')">
          <div class="vx-col flex-1">
            <div class="vx-row flex-1 mt-5">
              <!-- <div class="vx-col flex-1" style="padding-left: 5px">
                <p>{{ $t('AnnualPlan') }}</p>
                <vs-select :disabled="$acl.check('trainee')" class="w-full"
                  v-model="CourseRegistrationModel.AnnualPlanID">
                  <vs-select-item :key="index" :value="item.ID" :text="item.Course.Name +
                    ' (' +
                    item.StartDate.split('T')[0] +
                    ')'
                    " v-for="(item, index) in annualPlans" />
                </vs-select>
                <span class="text-danger text-sm" v-show="errors.has('AnnualPlan')">{{ errors.first("AnnualPlan")
                }}</span>
              </div> -->


              <div class="vx-col flex-1" style="padding-left: 5px">
                <p>{{ $t('AnnualPlan') }}</p>
                <input type="text" v-model="searchQuery" placeholder="Search Annual Plans"
                  class="w-full p-2 border rounded" />
                <vs-select :disabled="$acl.check('trainee')" class="w-full"
                  v-model="CourseRegistrationModel.AnnualPlanID">
                  <vs-select-item :key="index" :value="item.ID" :text="item.Course.Name +
                    ' (' +
                    item.StartDate.split('T')[0] +
                    ')'
                    " v-for="(item, index) in filteredAnnualPlans" />
                </vs-select>
                <span class="text-danger text-sm" v-show="errors.has('AnnualPlan')">{{ errors.first("AnnualPlan")
                }}</span>
              </div>


              <div class="vx-col flex-1" style="padding-left: 5px">
                <!-- AssessmentType is course -->
                <p> {{ $t('CourseClass') }}</p>
                <v-select :disabled="$acl.check('trainee')" label="ClassNo" class="w-full" autocomplete
                  v-model="CourseRegistrationModel.CourseClassID" :options="courseClass" :reduce="(ID) => ID.ID" />

                <span class="text-danger text-sm" v-show="errors.has('CourseClass')">{{ errors.first("CourseClass")
                }}</span>
              </div>
            </div>

            <div class="vx-row flex-1 mt-5">
              <div class="vx-col flex-1" style="padding-left: 5px">
                <p>{{ $t('Trainee') }}</p>
                <v-select :disabled="$acl.check('trainee')" label="FullName" class="w-full" autocomplete
                  v-model="CourseRegistrationModel.TraineeID" :options="trainees" :reduce="(ID) => ID.ID" @input="getRequireVisaForTrainee(CourseRegistrationModel.TraineeID)
                    " />

                <span class="text-danger text-sm" v-show="errors.has('Trainee')">{{ errors.first("Trainee") }}</span>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col flex-1 pl-1" v-if="CourseRegistrationModel.TraineeID">
                <vs-input :label="$t('Country')" v-model="TraineeCountry" class="mt-5 w-full" :disabled="true" />
              </div>
              <div class="vx-col" style="padding-left: 5px; margin-top: 25px" v-if="CourseRegistrationModel.TraineeID">
                <label> {{ $t('RequireVisa') }}</label>
                <vs-checkbox v-model="RequireVisa" :disabled="true"></vs-checkbox>
              </div>
            </div>

            <div class="vx-row flex-1 mt-5">
              <div class="vx-col flex-1 pl-1">
                <p>{{ $t('PaymentType') }}</p>
                <v-select :disabled="$acl.check('trainee')" label="Name" class="w-full" autocomplete
                  v-model="CourseRegistrationModel.PaymentTypeID" :options="PaymentTypes" :reduce="(ID) => ID.ID" />

                <span class="text-danger text-sm" v-show="errors.has('PaymentType')">{{ errors.first("PaymentType")
                }}</span>
              </div>

              <div v-if="CourseRegistrationModel.PayedCustomerID" class="vx-col flex-1" style="margin-top: 25px">
                <label> {{ $t('Confirm') }}</label>
                <vs-checkbox v-model="CourseRegistrationModel.IsCustomerConfirmed" :disabled="true"></vs-checkbox>
              </div>
            </div>

            <div class="vx-row flex-1 mt-5">
              <div class="vx-col flex-1 pl-1">
                <p>{{ $t('Diploma') }}</p>
                <v-select :disabled="$acl.check('trainee')" label="Name" class="w-full" autocomplete
                  v-model="CourseRegistrationModel.CourseTrackID" :options="tracks" :reduce="(ID) => ID.ID" />
                <p class="text-warning">
                  {{ $t('TraineeSelectCourse') }}
                </p>
              </div>
            </div>


          </div>
        </vx-card>
        <br />
        <vx-card v-if="CourseRegistrationModel.StatusID == 3" class="flex-1" title="Admission test">
          <vs-table pagination :max-items="5" :data="CourseRegistrationModel.RegistrationGeneralExams"
            style="padding-top: 15px">
            <template slot="thead">
              <vs-th>{{ $t('ExamCode') }} </vs-th>
              <vs-th>{{ $t('Result') }} </vs-th>
            </template>

            <template slot-scope="{ data }">
              <tbody>
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td>
                    <p>{{ tr.CourseClassExam.Code }}</p>
                  </vs-td>
                  <vs-td>
                    <p style="width: 100px">{{ tr.Result.toFixed(2) }}</p>
                  </vs-td>
                </vs-tr>
              </tbody>
            </template>
          </vs-table>
        </vx-card>

        <vx-card title="accommodation" v-if="CourseRegistrationModel.StatusID == 7">
          <div class="vx-row p-5">
            <vs-checkbox class="flex-1" :disable="false" v-model="CourseRegistrationModel.IsAccommodation">{{
              $t('WithAccommodation') }}</vs-checkbox>
            <vs-input class="flex-1" :label="$t('RoomType')" :disable="false"
              v-model="CourseRegistrationModel.RoomType"></vs-input>
          </div>
        </vx-card>

        <vx-card class="mt-5" :title="$t('TraineeVisaInfo')" v-if="CourseRegistrationModel.StatusID >= 7">
          <div class="vx-row p-5">
            <vs-input class="vx-col lg:w-1/2" :label="$t('NameAsPassport')" :disable="true"
              v-model="CourseRegistrationModel.NameASPassport"></vs-input>
            <vs-input class="vx-col lg:w-1/2" :label="$t('PassportNo')" :disable="true"
              v-model="CourseRegistrationModel.PassportNo"></vs-input>
          </div>
          <vs-table>
            <template slot="thead">
              <vs-th>{{ $t('DownloadVisaApprove') }}</vs-th>
              <vs-th>{{ $t('DownloadInvitationLetter') }}</vs-th>
              <vs-th>{{ $t('DownloadPlacementLetter') }}</vs-th>
            </template>
            <vs-tr>
              <vs-td>
                <a class="mt-5" v-if="CourseRegistrationModel.VisaProof"
                  :href="baseURL + CourseRegistrationModel.VisaProof" download target="_blank"><feather-icon
                    icon="DownloadIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" /></a>
              </vs-td>
              <vs-td>
                <a class="mt-5" v-if="CourseRegistrationModel.InvitationPath"
                  :href="baseURL + CourseRegistrationModel.InvitationPath" download target="_blank"><feather-icon
                    icon="DownloadIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" /></a>
              </vs-td>
              <vs-td>
                <a class="mt-5" v-if="CourseRegistrationModel.PlacementPath"
                  :href="baseURL + CourseRegistrationModel.PlacementPath" download target="_blank"><feather-icon
                    icon="DownloadIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" /></a>
              </vs-td>
            </vs-tr>
          </vs-table>
        </vx-card>

        <vx-card class="flex-1" title="Invoices " v-if="CourseRegistrationModel.InvoiceDetails &&
          CourseRegistrationModel.InvoiceDetails.length > 0
          " style="margin-top: 15px">
          <vs-table pagination :max-items="5" :data="CourseRegistrationModel.InvoiceDetails" style="padding-top: 15px">
            <template slot="thead">
              <vs-th>{{ $t('Amount') }}</vs-th>
              <vs-th>{{ $t('IsPayed') }}</vs-th>
              <vs-th>{{ $t('InvoiceAttachement') }}</vs-th>
              <vs-th v-if="CourseRegistrationModel.PaymentTypeID == 2">{{ $t('ConfirmPayAttachement') }}</vs-th>
            </template>
            <template slot-scope="{ data }">
              <tbody>
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data"
                  :style="{ 'background-color': tr.ColorCode }">
                  <vs-td>
                    <p class="product-name font-medium truncate" v-if="tr.Amount">
                      {{ tr.Amount.toFixed(2) }}
                    </p>
                  </vs-td>
                  <vs-td>
                    <vs-checkbox color="success" :disabled="CourseRegistrationModel.PaymentTypeID != 1 &&
                      CourseRegistrationModel.PaymentTypeID != 2
                      " v-model="tr.IsPayed"></vs-checkbox>
                  </vs-td>
                  <td>
                    <a v-if="tr.Invoice.AttachmentUrl" :href="baseURL + tr.Invoice.AttachmentUrl" download
                      target="_blank"><feather-icon icon="DownloadIcon"
                        svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" /></a>
                  </td>
                  <td v-if="CourseRegistrationModel.PaymentTypeID == 2">
                    <a v-if="tr.ConfirmPayAttachement" :href="baseURL + tr.ConfirmPayAttachement" download
                      target="_blank"><feather-icon icon="DownloadIcon"
                        svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" /></a>
                  </td>
                </vs-tr>
              </tbody>
            </template>
          </vs-table>
        </vx-card>
      </div>
      <div class="vx-col lg:w-1/2 w-full">
        <vx-card class="flex-1" :title="$acl.check('customertrainee') ? $t('Status') : $t('StatusHistory')">
          <div class="vx-row flex-1" v-if="!$acl.check('customertrainee')">
            <div class="vx-col flex-1">
              <p>{{ $t('Status') }}</p>
              <v-select :disabled="!CourseRegistrationModel.ID || $acl.check('customertrainee')
                " label="Name" class="flex-1" autocomplete v-model="CourseRegistrationModel.StatusID"
                :options="statusList" :reduce="(ID) => ID.ID" @input="getMailTemplate" />
            </div>
          </div>
          <div class="vx-row mt-2">
            <vs-input class="flex-1 ml-5" :label="$t('StatusComment')" v-model="CourseRegistrationModel.StatusComment"
              :disabled="!CourseRegistrationModel.ID || $acl.check('customertrainee')
                " name="StatusComment" />
            <vs-button class="ml-5 mr-5 mt-4" type="border" color="danger" :disabled="!CourseRegistrationModel.ID || $acl.check('customertrainee')
              " @click="SendMail()">Send Mail</vs-button>
          </div>
          <vs-table :max-items="5" :data="CourseRegistrationModel.StatusHistories"
            style="padding-top: 15px; overflow-x: hidden; display: block">
            <template slot="thead">
              <vs-th>{{ $t('StatusName') }}</vs-th>
              <vs-th>{{ $t('Comment') }}</vs-th>
            </template>

            <template slot-scope="{ data }" style="width: 50%">
              <tbody>
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data"
                  :style="{ 'background-color': tr.ColorCode }">
                  <vs-td>
                    <p class="product-name font-medium truncate">
                      {{ tr.Status.Name }}
                    </p>
                  </vs-td>
                  <vs-td>
                    <p class="product-name font-medium truncate">
                      {{ tr.Comment }}
                    </p>
                  </vs-td>
                </vs-tr>
              </tbody>
            </template>
          </vs-table>
        </vx-card>
        <div v-if="CourseRegistrationModel.InvoiceDetails.length > 0 &&
          CourseRegistrationModel.PaymentTypeID == 2
          ">
          <vx-card :title="$t('InvoiceAttachement')" class="mt-5" v-if="$acl.check('trainee') &&
            CourseRegistrationModel.InvoiceDetails &&
            !CourseRegistrationModel.InvoiceDetails[0].ConfirmPayAttachement
            ">
            <h6 style="color: orange">{{ $t('PleaseUploadPaymentProof') }}</h6>
            <vs-upload automatic :limit="1" :action="uploadUrl" :headers="UploadRequestHeader"
              @on-success="successUploadPayProof" />
          </vx-card>
        </div>

        <vx-card v-if="!$acl.check('customertrainee')" class="flex-1 mt-5" :title="$t('MailHistory')">
          <vs-table pagination :max-items="5" :data="CourseRegistrationModel.MailHistories" style="padding-top: 15px">
            <template slot="thead">
              <vs-th>{{ $t('MailBody') }} </vs-th>
              <vs-th>{{ $t('Action') }}</vs-th>
            </template>

            <template slot-scope="{ data }">
              <tbody>
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data"
                  :style="{ 'background-color': tr.ColorCode }">
                  <vs-td>
                    <p v-html="tr.MailBody.length > 30
                      ? tr.MailBody.substring(0, 30)
                      : tr.MailBody
                      "></p>
                  </vs-td>
                  <vs-td>
                    <feather-icon icon="InfoIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" class="ml-2"
                      @click="viewMail(tr)" />
                    <a v-if="tr.AttachmentUrl" :href="baseURL + tr.AttachmentUrl" download target="_blank"><feather-icon
                        icon="DownloadIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" /></a>
                  </vs-td>
                </vs-tr>
              </tbody>
            </template>
          </vs-table>
        </vx-card>
        <vx-card :title="$t('VisaProof')" class="mt-5" style="min-height: 50px"
          v-if="$acl.check('trainee') && RequireVisa">
          <h6 style="color: orange">{{ $t('PleaseUploadVisaProof') }}</h6>
          <vs-upload automatic :limit="1" :action="uploadUrl" :headers="UploadRequestHeader"
            @on-success="successUploadVisaProof" />
        </vx-card>
      </div>
    </div>

    <vs-prompt :title="$t('StatusMail')" accept-text="Send Mail" @accept="SaveMail"
      :is-valid="StatusModel.MailTemplate != undefined && !isViewMail" :active.sync="activePrompt">
      <VuePerfectScrollbar class="scroll-area p-4" :settings="settings">
        <form @submit.prevent style="max-height: 75vh; overflow-y: scroll">
          <vs-input name="mailSubject" :disabled="isViewMail" :label-placeholder="$t('Subject')"
            v-if="StatusModel.MailTemplate" v-model="StatusModel.MailTemplate.Subject" class="w-full mb-6" />
          <quill-editor :disabled="isViewMail" v-if="StatusModel.MailTemplate" v-model="StatusModel.MailTemplate.Body"
            :options="editorOption" />

          <vs-upload automatic :limit="1" v-if="StatusModel.MailTemplate && !isViewMail" :action="uploadUrl"
            :headers="UploadRequestHeader" @on-success="successUpload" />

          <div class="mt-2" v-if="isViewMail && StatusModel.MailTemplate.StatusMailAttachmnet">
            <span>{{ $t('DownloadAttachement') }}</span>
            <a :href="baseURL + StatusModel.MailTemplate.StatusMailAttachmnet" download target="_blank"><feather-icon
                icon="DownloadIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" /></a>
          </div>
          <vs-button class="ml-5 mt-4" v-if="StatusModel.MailTemplate" type="border" color="danger"
            @click="ShowStatusMailPreview = !ShowStatusMailPreview">{{ ShowStatusMailPreview ? "Hide" : "Preview"
            }}</vs-button>

          <vx-card v-if="ShowStatusMailPreview" class="mt-5">
            <p style="max-width: 70%; margin: auto" v-html="StatusModel.MailTemplate.Body"></p>
          </vx-card>
          <p v-if="!StatusModel.MailTemplate">
            {{ $t('MailStatusNot') }}
          </p>
        </form>
      </VuePerfectScrollbar>
    </vs-prompt>
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button v-if="!$acl.check('trainee')" class="ml-auto mt-2" @click="save_changes" :disabled="!validateForm">{{
            $t('Submit') }}
          </vs-button>
          <vs-button class="ml-4 mt-2" type="border" color="danger" @click="cancel">{{ $t('Cancel') }}</vs-button>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import vSelect from "vue-select";
import moduleCustomer from "@/store/user/customer/moduleCustomer.js";
import moduleTrainee from "@/store/user/trainee/moduleTrainee.js";
import Datepicker from "vuejs-datepicker";
import moduleAnnualPlan from "@/store/annualPlan/moduleAnnualPlan.js";
import modulePaymentType from "@/store/settings/paymentType/modulePaymentType.js";
import moduleStatus from "@/store/settings/status/moduleStatus.js";
import moduleCourseClass from "@/store/courseClass/moduleCourseClass.js";

import moduleTrack from "@/store/track/moduleTrack.js";

import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import { quillEditor } from "vue-quill-editor";
import { domain, mainSetting } from "@/gloabelConstant.js";
import { toolbar } from "@/gloabelConstant.js";
import moduleCourseRegistration from "@/store/courseRegistration/moduleCourseRegistration.js";

export default {
  components: {
    vSelect,
    Datepicker,
    quillEditor,
  },
  data() {
    return {
      searchQuery: '',
      ShowStatusMailPreview: false,
      UploadRequestHeader: mainSetting.UploadRequestHeader,
      baseURL: domain,
      selected: [],
      activePrompt: false,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.3,
      },
      itemsPerPage: 10,
      isViewMail: false,
      isMounted: false,
      CourseRegistrationModel: {
        StatusHistories: [],
        MailHistories: [],
        InvoiceDetails: [],
      },
      switch1: 2,
      listOfStatus: [],
      TraineeCountry: "",
      RequireVisa: false,
      status: { Status: {} },
      statusList: [],
      oldStatus: 0,
      uploadUrl: domain + "API/Course/UploadFile",
      StatusModel: { MailTemplate: {} },
      editorOption: {
        modules: {
          toolbar: toolbar,
        },
        placeholder: "Message",
      },
    };
  },
  computed: {
    filteredAnnualPlans() {
      if (this.searchQuery.trim() === '') {
        return this.annualPlans;  // Return all options if search query is empty
      } else {
        const query = this.searchQuery.toLowerCase();
        return this.annualPlans.filter(item => {
          const text = item.Course.Name.toLowerCase() + ' (' + item.StartDate.split('T')[0] + ')';
          return text.includes(query);
        });
      }
    },
    tracks() {
      return this.$store.state.trackList.tracks;
    },
    validateForm() {
      return true;
    },
    trainees() {
      return this.$store.state.traineeList.trainees;
    },
    customers() {
      return this.$store.state.customerList.customers;
    },
    annualPlans() {
      return this.$store.state.annualPlanList.annualPlans;
    },
    PaymentTypes() {
      return this.$store.state.PaymentTypeList.PaymentTypes;
    },
    Statuses() {
      return this.$store.state.StatusList.Statuses;
    },
    courseClass() {
      return this.$store.state.courseClassList.courseClass;
    },
    statuList() {
      if (this.$store.state.StatusList != undefined)
        return this.$store.state.StatusList.Statuses.filter(function (e) {
          if (e.ID == 1) return e;
        });
    },
  },

  methods: {
    SendMail() {
      debugger;
      var vm = this;
      if (
        this.statusList.findIndex(
          (e) => e.ID == vm.CourseRegistrationModel.StatusID
        ) != -1 &&
        vm.CourseRegistrationModel.StatusID != this.oldStatus
      ) {
        this.activePrompt = true;
        this.isViewMail = false;
      }
    },
    initValues() {
      this.CourseRegistrationModel = {
        StatusHistories: [],
        MailHistories: [],
      };
    },

    cancel() {
      if (this.$acl.check("trainee")) this.$router.push("/FollowRegistration");
      else this.$router.go(-1);
    },

    successUpload(event) {
      this.CourseRegistrationModel.StatusMailAttachmnet =
        event.target.responseText;
      this.$vs.notify({
        color: "success",
        text: this.$t("SuccessuploadyourAttachment")
      });
    },

    successUploadPayProof(event) {
      var obj = {};
      obj.CourseRegistrationID = this.CourseRegistrationModel.ID;
      obj.ConfirmPayAttachement = event.target.responseText;
      this.$store.dispatch("courseRegistrationList/SavePaymentProof", obj);
      this.$vs.notify({
        color: "success",
        title: "Upload Success",
        text: this.$t("SuccessuploadyourAttachment")
      });
    },

    successUploadVisaProof(event) {
      var obj = {};
      obj.ID = this.CourseRegistrationModel.ID;
      obj.VisaProof = event.target.responseText;
      this.$store.dispatch("courseRegistrationList/SaveVisaProof", obj);
      this.$vs.notify({
        color: "success",
        title: "Upload Success",
        text: this.$t("SuccessuploadyourAttachment")
      });
    },

    getMailTemplate() {
      debugger;
      this.$store
        .dispatch(
          "StatusList/GetItemByID",
          this.CourseRegistrationModel.StatusID
        )
        .then((res) => {
          debugger;
          this.StatusModel = res.data;
        });
    },

    getSatus(ID) {
      this.statusList = [];
      this.oldStatus = ID;

      if (ID != undefined) {
        this.statusList = this.$store.state.StatusList.Statuses.filter(
          function (e) {
            debugger;
            if (e.ID == ID) {
              return e;
            }
            else if (
              e.ParentStatusID != null &&
              e.ParentStatusID != undefined
            ) {
              var asd = e.ParentStatusID.split(",");
              if (asd.includes(ID.toString())) return e;
            }
          }
        );
      } else this.statusList = this.$store.state.StatusList.Statuses;
    },

    viewMail(mail) {
      this.StatusModel.MailTemplate.Body = mail.MailBody;
      this.StatusModel.MailTemplate.StatusMailAttachmnet = mail.AttachmentUrl;
      this.isViewMail = true;
      this.activePrompt = true;
    },

    SaveMail() {
      this.listOfStatus = this.CourseRegistrationModel.StatusHistories;

      this.CourseRegistrationModel.StatusHistories = this.listOfStatus;
      this.CourseRegistrationModel.IsSendMail = true;
      this.ShowStatusMailPreview = false;
    },

    save_changes() {
      debugger;
      this.CourseRegistrationModel.IsSendMail = true;
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (
            this.CourseRegistrationModel.ID !== null &&
            this.CourseRegistrationModel.ID >= 0
          ) {
            this.$vs.loading();
            this.$store
              .dispatch(
                "courseRegistrationList/updateItem",
                this.CourseRegistrationModel
              )
              .then(() => {
                this.$vs.loading.close();
                this.initValues();
                this.$router.go(-1);
              })
              .catch((error) => {
                this.$vs.loading.close();
              });
          } else {
            this.$vs.loading();
            this.$store
              .dispatch(
                "courseRegistrationList/addItem",
                this.CourseRegistrationModel
              )
              .then(() => {
                this.$vs.loading.close();
              })
              .catch((error) => {
                this.$vs.loading.close();
              });
            this.initValues();
            this.$router.go(-1);
          }
        }
      });
    },
    getRequireVisaForTrainee(id) {
      this.$store.state.traineeList.trainees.forEach((element) => {
        if (element.ID == id) {
          this.TraineeCountry = element.Country.Name;
          this.RequireVisa = element.Country.RequireVisa;
        }
      });
    },
  },

  created() {
    if (!moduleCustomer.isRegistered) {
      this.$store.registerModule("customerList", moduleCustomer);
      moduleCustomer.isRegistered = true;
    }
    if (!moduleCourseRegistration.isRegistered) {
      this.$store.registerModule("courseRegistrationList", moduleCourseRegistration);
      moduleCourseRegistration.isRegistered = true;
    }
    if (!moduleTrainee.isRegistered) {
      this.$store.registerModule("traineeList", moduleTrainee);
      moduleTrainee.isRegistered = true;
    }
    this.$store.dispatch("traineeList/fetchDataListItems");

    if (!moduleAnnualPlan.isRegistered) {
      this.$store.registerModule("annualPlanList", moduleAnnualPlan);
      moduleAnnualPlan.isRegistered = true;
    }
    this.$store.dispatch("annualPlanList/fetchDataListItemsAll");

    if (!modulePaymentType.isRegistered) {
      this.$store.registerModule("PaymentTypeList", modulePaymentType);
      modulePaymentType.isRegistered = true;
    }
    if (this.$store.state.PaymentTypeList.PaymentTypes.length == 0)
      this.$store.dispatch("PaymentTypeList/fetchDataListItems");

    if (!moduleStatus.isRegistered) {
      this.$store.registerModule("StatusList", moduleStatus);
      moduleStatus.isRegistered = true;
    }
    this.$store.dispatch("StatusList/fetchDataListItems");

    if (!moduleTrack.isRegistered) {
      this.$store.registerModule("trackList", moduleTrack);
      moduleTrack.isRegistered = true;
    }

    if (!moduleCourseClass.isRegistered) {
      this.$store.registerModule("courseClassList", moduleCourseClass);
      moduleCourseClass.isRegistered = true;
    }
    this.$store.dispatch("courseClassList/fetchDataListItems");

    const ID = this.$route.params.ID;
    if (ID != undefined) {
      this.$vs.loading();
      this.$store
        .dispatch("courseRegistrationList/GetItemByID", ID)
        .then((res) => {
          this.CourseRegistrationModel = res.data;
          var x = this.CourseRegistrationModel.InvoiceDetails;
          debugger

          if (this.$acl.check("customertrainee")) {
            this.CourseRegistrationModel.StatusHistories =
              this.CourseRegistrationModel.StatusHistories.slice(0, 1);
          }
          this.getSatus(this.CourseRegistrationModel.StatusID);
          this.CourseRegistrationModel.StatusComment = "";
          this.CourseRegistrationModel.IsSendMail = false;
          this.getRequireVisaForTrainee(this.CourseRegistrationModel.TraineeID);
          if (this.CourseRegistrationModel.CustomerID != null) this.switch1 = 2;
          else this.switch1 = 1;

          if (this.CourseRegistrationModel.InvoiceDetails == undefined)
            this.CourseRegistrationModel.InvoiceDetails = [];
          var search = {};
          search.CourseID = res.data.AnnualPan.CourseID;
          this.$store.dispatch("trackList/fetchDataListItemsByFilter", search);
          this.$vs.loading.close();
        })
        .catch((err) => {
          this.$vs.loading.close();
          if (err.response.status === 404) {
            this.user_not_found = true;
            return;
          }
          console.error(err);
        });
    } else {
      //  this.$store.dispatch("StatusList/fetchDataListItems").then(()=>{
      //   //this.getSatus();
      //  });
      this.CourseRegistrationModel.StatusID = 1;
      this.getSatus();
    }
  },
  mounted() {
    this.isMounted = true;
  },
};
</script>

<style lang="scss">
@media (max-width: 550px) {
  .con-select {
    flex-direction: column;
  }

  .con-select .vs-select {
    width: 100%;
  }
}

.con-select-example {
  display: flex;
  align-items: center;
  justify-content: center;
}

#data-list-list-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;

      >span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);

        td {
          padding: 20px;

          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }

          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }

        td.td-check {
          padding: 10px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 400;
        }
      }

      th.td-check {
        padding: 0 15px !important;
      }

      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}

.vs-table--not-data {
  display: none;
}</style>
